/* global google */

import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {TabContent, TabPane, Nav, NavItem, NavLink} from 'reactstrap';
import {
    Button,
    ButtonDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from 'reactstrap';
import classnames from 'classnames';

import $ from "jquery";
import Geosuggest from 'react-geosuggest';
import TinyMCE from 'react-tinymce';
import ReactTags from 'react-tag-input';
import SweetAlert from 'react-bootstrap-sweetalert';
import ReactNotify from 'react-notify';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

import firebase from 'firebase';
import _HauteFire from '../../Utils/HauteFire';

const HauteFire = new _HauteFire();
const _ReactTags = ReactTags.WithContext;

export default class AddUpdateIsland extends Component {
    constructor(props) {
        super(props);

        this.state = {
            islandInfo: {},
            islandActiveTab: 'tab_General',
            islandRoomsActiveTab: 'tab_Rooms_General',
            roomFeatures: [],
            activities: [],
            fileBannerPic: {},
            fileLogo: {},
            filePrivatePic: {},
            filesIslandPics: [],
            filesIslandRoomPics: [],
            roomsModal: false,
            activeRoomInfo: {},
            sweetAlertShow: null,
            deleteRoomId: "",
            deleteRoomName: "",
            sweetAlertDelete: null,
            islandCategories: [],
            editContactId: ""
        };
    }

    componentDidMount() {
        $(document).on("change", "#fileBanner", this.setIslandBanner.bind(this));
        $(document).on("change", "#fileLogo", this.setIslandLogo.bind(this));
        $(document).on("change", "#filePrivate", this.setIslandPrivatePic.bind(this));
        $(document).on("change", "#fileIslandPics", this.setIslandOtherPics.bind(this));
        $(document).on("change", "#fileIslandRoomPics", this.setIslandRoomPics.bind(this));

        $(document).on("click", "div.img-island", this.removeIslandPic.bind(this));

        $(document).on("click", "div.img-room", this.removeIslandRoomsPic.bind(this));
        $(document).on("click", "div.deletePic", this.deleteIslandRoomUrl.bind(this));
        $(document).on("change", ".chkAllRoomActive", this.changeRoomActiveStatus.bind(this));
        $(document).on("click", ".btnRoomDelete", this.showDeleteModal.bind(this));
        $(document).on("click", ".btnRoomEdit", this.fillActiveRoomInfo.bind(this));

        $("body").on("click", "a.edit-contact", this.editContact.bind(this));
        // $("a.edit-contact").on("click", this.editContact.bind(this));
        $("body").on("click", "a.delete-contact", this.deleteContact.bind(this));

        $("div.mce-tinymce").css("width", "100%");

        this.toggleIslandTabs = this.toggleIslandTabs.bind(this);
        this.toggleRoomsModal = this.toggleRoomsModal.bind(this);

        const params = this.props.match.params, _this = this;
        if (!$.isEmptyObject(params)) {
            const id = params.id;
            if (id != undefined) {
                const islandRef = firebase.database().ref("/IslandDetails/" + id);
                islandRef.on('value', ((response) => {
                    const islandInfo = response.val();
                    if (islandInfo) {
                        _this.setState({islandInfo}, () => {
                            _this.setIslandValues()
                        });

                        // _this.setIslandValues();
                    }
                }))
            }
            else {
                let islandInfo = {};
                islandInfo.continent = "Asia";
                _this.setState({islandInfo});
            }
        }
        else {
            let islandInfo = {};
            islandInfo.continent = "Asia";
            _this.setState({islandInfo});
        }
        this.fillCategories();
    }

    fillCategories() {
        const _this = this;
        let categoryRef = firebase.database().ref("CategoryDetails/");
        categoryRef.on('value', ((response) => {
            let islandCategories = response.val();
            if (islandCategories != null) {
                let keys = Object.keys(islandCategories);
                islandCategories = keys.map((key) => {
                    return islandCategories[key]
                });

                _this.setState({islandCategories});
            }
        }))
    }

    componentWillReceiveProps(nextProps) {
        // this.props = nextProps;
        // this.componentDidMount();

        const params = nextProps.match.params;
        if ($.isEmptyObject(params)) {
            $("#txtIslandName").val("");
            $("#txtIslandRooms").val("");
            $("#txtIslandGuests").val("");
            $("#txtIslandPrice").val("");
            $("#txtIslandTagLine").val("");
            let descriptionBody = $("iframe")[0].contentWindow.document.body;   //description
            if (descriptionBody) {
                descriptionBody.innerHTML = "";
            }

            this.setState({
                islandInfo: {}, islandActiveTab: 'tab_General',
                islandRoomsActiveTab: 'tab_Rooms_General',
                activities: [],
                roomFeatures: [],
                fileBannerPic: {},
                fileLogo: {},
                filePrivatePic: {},
                filesIslandPics: [],
                filesIslandRoomPics: [],
                roomsModal: false,
                activeRoomInfo: {},
                sweetAlertShow: null,
                deleteRoomId: "",
                deleteRoomName: "",
                sweetAlertDelete: null,
                islandCategories: []
            });
            this.fillCategories();
        }
        else {
            this.componentDidMount();
        }
    }

    setIslandValues() {
        const islandInfo = this.state.islandInfo;
        if (islandInfo) {
            $("#txtIslandName").val(islandInfo.name);   //name
            $("#txtIslandRooms").val(islandInfo.rooms);
            $("#txtIslandGuests").val(islandInfo.guests);
            $("#txtIslandPrice").val(islandInfo.price);
            $("#txtIslandTagLine").val(islandInfo.tagLine);
            if (islandInfo.hasOwnProperty('continent')) {
                $("#dlContinent").val(islandInfo.continent);
            }
            else {
                islandInfo.continent = "Asia";
                $("#dlContinent").val("Asia");
            }
            let activities = islandInfo.activities;
            if (activities) {
                activities = activities.map((obj, index) => {
                    return {id: (index + 1), text: obj}
                });
                this.setState({activities});
            }

            // let descriptionBody = document.getElementById("react-tinymce-0_ifr").contentWindow.document.body;   //description
            let descriptionBody = $("iframe")[0].contentWindow.document.body;   //description
            if (descriptionBody) {
                descriptionBody.innerHTML = islandInfo.description;
            }

            if (islandInfo.islandPics) {
                const islandPics = islandInfo.islandPics;
                if (islandPics) {
                    const logoPic = islandPics.logoPic;
                    if (logoPic) {  //logo picture
                        $("img#imgIslandLogo").attr("src", logoPic.url);
                    }
                    const bannerPic = islandPics.bannerPic;
                    if (bannerPic) {    //banner picture
                        $("img#imgIslandBanner").attr("src", bannerPic.url);
                    }
                }
            }

        }
    }

    renderCategoriesOpts(option) {
        let selectedOpt = "";
        const categories = this.state.islandInfo.category;
        if (categories) {
            let category = categories.filter((category) => {
                return category.id == option.id
            });
            if (category.length > 0) {
                selectedOpt = "selected";
            }
        }

        return (<option key={option.id} data-id={option.id} data-name={option.name}
                        selected={selectedOpt} value={option.name}>{option.name}</option>);
    }

    addRoomsToggleModal() {
        $("div#divIslandRoomPics").html("");
        $("#txtRoomName").focus();

        let activeRoomInfo = {isCommonFeatures: true, defaultOcc: 3, minOcc: 1, maxOcc: 2, isActive: true}

        this.setState({
                activeRoomInfo,
                roomsModal: !this.state.roomsModal
            }
        );
    }

    toggleRoomsModal() {
        this.setState({
                roomsModal: !this.state.roomsModal
            }
        );
    }

    setIslandBanner(e) {
        let _file = e.currentTarget.files[0];
        if (!$.isEmptyObject(_file)) {
            let reader = new FileReader();
            reader.onload = (e) => {
                $("#imgIslandBanner").attr("src", e.target.result);
            };
            reader.readAsDataURL(_file);
            this.setState({fileBannerPic: _file});

            document.getElementById("fileBanner").value = "";
        }
    }

    setIslandLogo(e) {
        let _file = e.currentTarget.files[0];
        if (!$.isEmptyObject(_file)) {
            let reader = new FileReader();
            reader.onload = (e) => {
                $("#imgIslandLogo").attr("src", e.target.result);
            };
            reader.readAsDataURL(_file);
            this.setState({fileLogo: _file});

            document.getElementById("fileLogo").value = "";
        }
    }

    setIslandPrivatePic(e) {
        let _file = e.currentTarget.files[0];
        if (!$.isEmptyObject(_file)) {
            let reader = new FileReader();
            reader.onload = (e) => {
                $("#imgIslandPrivate").attr("src", e.target.result);
            };
            reader.readAsDataURL(_file);
            this.setState({filePrivatePic: _file});

            document.getElementById("filePrivate").value = "";
        }
    }

    setIslandOtherPics(e) {
        let _files = e.currentTarget.files;
        if (_files.length > 0) {
            let filesIslandPics = this.state.filesIslandPics;
            for (let i = 0; i < _files.length; i++) {
                if (_files[i]) {
                    const id = new Date().getTime() + i;
                    filesIslandPics.push({id, file: _files[i]});
                }
            }
            this.setState({filesIslandPics});
            //make file object empty
            document.getElementById("fileIslandPics").value = "";
        }
    }

    setIslandRoomPics(e) {
        let _files = e.currentTarget.files;
        if (_files.length > 0) {
            let filesIslandRoomPics = this.state.filesIslandRoomPics;
            for (let i = 0; i < _files.length; i++) {
                if (_files[i]) {
                    let id = new Date().getTime() + i;
                    filesIslandRoomPics.push({id, file: _files[i]});
                }
            }
            this.setState({filesIslandRoomPics});
            //make file object empty
            document.getElementById("fileIslandRoomPics").value = "";
        }
    }

    beforeSetPicsHtml(isRoomPart) {
        if (isRoomPart) {
            $("div#divIslandRoomPics").html("");

            if (this.state.filesIslandRoomPics.length > 0) {
                this.setPicsHtml(this.state.filesIslandRoomPics, "divIslandRoomPics", true);
            }
            if (this.state.activeRoomInfo) {
                if (this.state.activeRoomInfo.roomPics) {
                    this.setPicsHtml(this.state.activeRoomInfo.roomPics, "divIslandRoomPics", false);
                }
            }
        }
        else {
            $("div#divIslandPics").html("");

            // $("div.img-island").unbind("click");
            if (this.state.filesIslandPics.length > 0) {
                this.setPicsHtml(this.state.filesIslandPics, "divIslandPics", true);
            }
            if (!$.isEmptyObject(this.state.islandInfo)) {
                if (this.state.islandInfo.islandPics) {
                    if (this.state.islandInfo.islandPics.otherPics) {
                        this.setPicsHtml(this.state.islandInfo.islandPics.otherPics, "divIslandPics", false);
                    }
                }
            }
            // $(document).on("click", "div.img-island", this.removeIslandPic.bind(this));
        }
    }

    setPicsHtml(stateName, divName, isFileObjExist) {
        const picClass = divName == "divIslandPics" ? "img-island" : "img-room";
        const delFolder = "divIslandPics" ? "IslandPics" : "RoomPics";
        divName = `#${divName}`;
        if (stateName) {
            if (isFileObjExist) {
                for (let _file of stateName) {
                    if (_file) {
                        const id = _file.id;
                        _file = _file.file;

                        let _html = "";
                        let reader = new FileReader();
                        reader.onload = (e) => {
                            _html = '<div class="col-md-4"> \
                            <div class="imgcard imgcard-cascade wider"> \
                                <div class="view overlay hm-white-slight"> \
                                    <img src=' + e.target.result + ' alt="Island Picture" class="img-fluid" /> \
                                </div> \
                                <div class="removePic ' + picClass + '" title="Delete" data-fileId=' + id + '> \
                                    <i class="fa fa-times-circle-o fa-lg" aria-hidden="true"></i> \
                                </div>\
                            </div> \
                        </div>';

                            $(divName).append(_html);
                        };
                        reader.readAsDataURL(_file);
                    }
                }
            }
            else {
                for (let file of stateName) {
                    if (file) {
                        let _html = '<div class="col-md-4"> \
                            <div class="imgcard imgcard-cascade wider"> \
                                <div class="view overlay hm-white-slight"> \
                                    <img src=' + file.url + ' alt="Island Picture" class="img-fluid" /> \
                                </div> \
                                <div class="removePic deletePic" title="Delete" data-picUrl=' + file.url + ' data-picName="' + file.name + '" data-folder=' + delFolder + '> \
                                    <i class="fa fa-times-circle-o fa-lg" aria-hidden="true"></i> \
                                </div>\
                            </div> \
                        </div>';

                        $(divName).append(_html);
                    }
                }
            }
        }
    }

    removeIslandPic(e) {
        let fileId = e.currentTarget.attributes["data-fileId"].value;
        if (fileId != (undefined || "")) {
            let filesIslandPics = this.state.filesIslandPics.filter((_file) => {
                return _file.id != fileId
            });
            if (filesIslandPics) {
                this.setState({filesIslandPics}, e.currentTarget.attributes["data-fileId"].value = "");
            }
        }
    }

    removeIslandRoomsPic(e) {
        let fileId = e.currentTarget.attributes["data-fileId"].value;
        if (fileId != undefined || "") {
            let filesIslandRoomPics = this.state.filesIslandRoomPics.filter((_file) => {
                return _file.id != fileId
            });
            if (filesIslandRoomPics) {
                this.setState({filesIslandRoomPics});
            }
        }
    }

    deleteIslandRoomUrl(e) {
        const _this = this;
        const picUrl = $(e.currentTarget).attr("data-picUrl");
        const picName = $(e.currentTarget).attr("data-picName");
        const delFolder = $(e.currentTarget).attr("data-folder");

        if (delFolder == "IslandPics") {
            HauteFire.deleteFile("IslandPics/resized/" + picName).then(() => {
                $("div#divIslandPics").html("");
                //delete pic from object
                let islandInfo = _this.state.islandInfo;
                let otherPics = islandInfo.islandPics.otherPics.filter((pic) => {
                    return pic.name != picName
                });
                islandInfo.islandPics.otherPics = otherPics;

                firebase.database().ref("IslandDetails/" + islandInfo.id + "/islandPics/otherPics").set(otherPics);
                _this.setState({islandInfo});
            }).catch((error) => {
                console.error(error);
            });
        }
        else {
            HauteFire.deleteFile("RoomPics/" + picName).then(() => {
                $("div#divIslandRoomPics").html("");
                //delete pic from object
                let activeRoomInfo = _this.state.activeRoomInfo;
                let roomPics = activeRoomInfo.roomPics.filter((pic) => {
                    return pic.name != picName
                });
                activeRoomInfo.roomPics = roomPics;
                _this.setState({activeRoomInfo});
            }).catch((error) => {
                console.error(error);
            });
        }
    }

    handleDelete(i) {
        let roomFeatures = this.state.roomFeatures;
        roomFeatures.splice(i, 1);

        let activeRoomInfo = this.state.activeRoomInfo;
        let features = activeRoomInfo.features || [];
        features = roomFeatures.map((feature) => {
            return feature.text
        });
        activeRoomInfo.features = features;

        this.setState({roomFeatures, activeRoomInfo});
    }

    handleActivityDelete(i) {
        let activities = this.state.activities;
        activities.splice(i, 1);

        let islandInfo = this.state.islandInfo;
        let islandActivities = islandInfo.activities || [];
        islandActivities = activities.map((feature) => {
            return feature.text
        });
        islandInfo.activities = islandActivities;

        this.setState({activities, islandInfo});
    }

    handleAddition(tag) {
        let roomFeatures = this.state.roomFeatures;
        let _tag = roomFeatures.filter((feature) => {
            return feature.text == tag.trim()
        });
        if (_tag.length == 0) {
            roomFeatures.push({
                id: roomFeatures.length + 1,
                text: tag
            });

            let activeRoomInfo = this.state.activeRoomInfo;
            let features = activeRoomInfo.features || [];
            features = roomFeatures.map((feature) => {
                return feature.text
            });
            activeRoomInfo.features = features;

            this.setState({roomFeatures, activeRoomInfo});
        }
    }

    handleActivitiesAddition(tag) {
        let activities = this.state.activities;
        let _tag = activities.filter((feature) => {
            return feature.text == tag.trim()
        });
        if (_tag.length == 0) {
            activities.push({
                id: activities.length + 1,
                text: tag
            });

            let islandInfo = this.state.islandInfo;
            let islandActivities = islandInfo.activities || [];
            islandActivities = activities.map((feature) => {
                return feature.text
            });
            islandInfo.activities = islandActivities;

            this.setState({activities, islandInfo});
        }
    }

    handleDrag(tag, currPos, newPos) {
        let roomFeatures = this.state.roomFeatures;

        // mutate array
        roomFeatures.splice(currPos, 1);
        roomFeatures.splice(newPos, 0, tag);

        let activeRoomInfo = this.state.activeRoomInfo;
        let features = activeRoomInfo.features || [];
        features = roomFeatures.map((feature) => {
            return feature.text
        });
        activeRoomInfo.features = features;

        // re-render
        this.setState({roomFeatures, activeRoomInfo});
    }

    handleActivitiesDrag(tag, currPos, newPos) {
        let activities = this.state.activities;

        // mutate array
        activities.splice(currPos, 1);
        activities.splice(newPos, 0, tag);

        let islandInfo = this.state.islandInfo;
        let islandActivities = islandInfo.activities || [];
        islandActivities = activities.map((feature) => {
            return feature.text
        });
        islandInfo.activities = islandActivities;

        // re-render
        this.setState({activities, islandInfo});
    }

    toggleIslandTabs(tab) {
        if (this.state.islandActiveTab !== tab) {
            this.setState({
                islandActiveTab: tab
            });
        }
    }

    toggleIslandRoomsTabs(tab) {
        if (this.state.islandRoomsActiveTab !== tab) {
            this.setState({
                islandRoomsActiveTab: tab
            });
        }
    }

    changeSuggestion(value) {
        let islandInfo = this.state.islandInfo;
        islandInfo.address = value.trim()

        this.setState({islandInfo});
    }

    changeIslandDescription(e) {
        let islandInfo = this.state.islandInfo;
        islandInfo.description = e.target.getContent();
        this.setState({islandInfo});
    }

    changeActiveRoomDescription(e) {
        let activeRoomInfo = this.state.activeRoomInfo;
        activeRoomInfo.description = e.target.getContent();
        this.setState({activeRoomInfo});
    }

    onSuggestSelect(suggest) {
        let islandInfo = this.state.islandInfo;
        islandInfo.location = suggest.location;
        islandInfo.address = suggest.description;

        this.setState({islandInfo});
    }

    renderIslandGenralPart() {
        return (<div className="card-block">
                <form className="form-2orizontal">
                    <div className="form-group">
                        <label className="form-control-label" htmlFor="txtIslandName">Name</label>
                        <div className="controls">
                            <div className="input-prepend input-group">
                                <input id="txtIslandName" className="form-control" size="16"
                                       type="text" placeholder="Name"
                                       onChange={(e) => {
                                           let islandInfo = this.state.islandInfo;
                                           islandInfo.name = e.currentTarget.value.trim();
                                           if (islandInfo.name != "") {
                                               this.setState({islandInfo})
                                           }
                                       }}/>
                            </div>

                        </div>
                    </div>
                    <div className="form-group">
                        <label className="form-control-label">Category</label>
                        <div className="controls">
                            <div className="input-prepend input-group">
                                <select id="dlCategory" multiple="multiple" onChange={(e) => {
                                    let selectedOpts = $(e.currentTarget).find(":selected");
                                    if (selectedOpts.length > 0) {
                                        let islandInfo = this.state.islandInfo;
                                        let category = [];
                                        selectedOpts.each((index, opt) => {
                                            let id = $(opt).attr("data-id");
                                            let name = $(opt).attr("data-name");

                                            category.push({id, name});
                                        });

                                        islandInfo.category = category;
                                        this.setState({islandInfo});
                                    }
                                }}>
                                    {this.state.islandCategories.length > 0 ? this.state.islandCategories.map((category) => {
                                        return this.renderCategoriesOpts(category)
                                    }) : ""}
                                </select>
                            </div>

                        </div>
                    </div>
                    <div className="form-group">
                        <label className="form-control-label" htmlFor="txtIslandAddress">Address</label>
                        <div className="controls">
                            <div className="input-group">
                                <Geosuggest
                                    initialValue={this.state.islandInfo.address || ""}
                                    placeholder="Search by island ..."
                                    onChange={this.changeSuggestion.bind(this)}
                                    onSuggestSelect={this.onSuggestSelect.bind(this)}
                                    location={new google.maps.LatLng(53.558572, 9.9278215)}
                                    radius="20"/>
                            </div>

                        </div>
                    </div>
                    <div className="form-group">
                        <label className="form-control-label">Activities</label>
                        <div className="controls">
                            <div className="input-group">
                                <_ReactTags tags={this.state.activities}
                                            handleDelete={this.handleActivityDelete.bind(this)}
                                            handleAddition={this.handleActivitiesAddition.bind(this)}
                                            handleDrag={this.handleActivitiesDrag.bind(this)}
                                            placeholder="Add activity"/>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="form-control-label" htmlFor="dlContinent">Continent</label>
                        <div className="controls">
                            <div className="input-group">
                                <select className="form-control" id="dlContinent" onChange={(e) => {
                                    let continent = e.currentTarget.value;
                                    let islandInfo = this.state.islandInfo;
                                    islandInfo.continent = continent;

                                    this.setState({islandInfo});
                                }}>
                                    <option value="Asia">Asia</option>
                                    <option value="Africa">Africa</option>
                                    <option value="North America">North America</option>
                                    <option value="South America">South America</option>
                                    <option value="Antarctica">Antarctica</option>
                                    <option value="Europe">Europe</option>
                                    <option value="Australia/Oceania">Australia/Oceania</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="form-control-label" htmlFor="txtIslandRooms">Rooms</label>
                        <div className="controls">
                            <div className="input-prepend input-group">
                                <input id="txtIslandRooms" className="form-control" size="16"
                                       type="number" placeholder="Rooms"
                                       onChange={(e) => {
                                           let islandInfo = this.state.islandInfo;
                                           islandInfo.rooms = e.currentTarget.value.trim();
                                           if (islandInfo.rooms != "") {
                                               this.setState({islandInfo})
                                           }
                                       }}/>
                            </div>

                        </div>
                    </div>
                    <div className="form-group">
                        <label className="form-control-label" htmlFor="txtIslandGuests">Guests</label>
                        <div className="controls">
                            <div className="input-prepend input-group">
                                <input id="txtIslandGuests" className="form-control" size="16"
                                       type="number" placeholder="Guests"
                                       onChange={(e) => {
                                           let islandInfo = this.state.islandInfo;
                                           islandInfo.guests = e.currentTarget.value.trim();
                                           if (islandInfo.guests != "") {
                                               this.setState({islandInfo})
                                           }
                                       }}/>
                            </div>

                        </div>
                    </div>
                    <div className="form-group">
                        <label className="form-control-label" htmlFor="txtIslandPrice">Price</label>
                        <div className="controls">
                            <div className="input-prepend input-group">
                                <input id="txtIslandPrice" className="form-control" size="16"
                                       type="number" placeholder="Price"
                                       onChange={(e) => {
                                           let islandInfo = this.state.islandInfo;
                                           islandInfo.price = e.currentTarget.value.trim();
                                           if (islandInfo.price != "") {
                                               this.setState({islandInfo})
                                           }
                                       }}/>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="form-control-label" htmlFor="txtIslandTagLine">Tag Line</label>
                        <div className="controls">
                            <div className="input-prepend input-group">
                                <input id="txtIslandTagLine" className="form-control" size="16"
                                       type="text" placeholder="Tag Line"
                                       onChange={(e) => {
                                           let islandInfo = this.state.islandInfo;
                                           islandInfo.tagLine = e.currentTarget.value.trim();
                                           if (islandInfo.tagLine != "") {
                                               this.setState({islandInfo})
                                           }
                                       }}/>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="form-control-label" htmlFor="txtIslandDescription">Description</label>
                        <div className="controls">
                            <div className="input-group" style={{width: '100%'}}>
                                <TinyMCE
                                    content={this.state.islandInfo.description}
                                    style={{width: '100%'}}
                                    onChange={this.changeIslandDescription.bind(this)}
                                />
                            </div>

                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-md-2 form-control-label" htmlFor="fileLogo">Logo</label>
                        <div className="col-md-4">
                            <input type="file" id="fileLogo" name="fileLogo" accept="image/*"/>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-md-2 form-control-label" htmlFor="filePrivate">Private</label>
                        <div className="col-md-4">
                            <input type="file" id="filePrivate" name="filePrivate" accept="image/*"/>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-md-2 form-control-label" htmlFor="fileBanner">Banner Picture</label>
                        <div className="col-md-4">
                            <input type="file" id="fileBanner" name="fileBanner" accept="image/*"/>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-md-2 form-control-label" htmlFor="fileIslandPics">Other Island
                            Pictures</label>
                        <div className="col-md-4">
                            <input type="file" id="fileIslandPics" name="fileIslandPics" accept="image/*" multiple/>
                        </div>
                    </div>

                    <div data-reactroot="" className="flex-row align-items-center">
                        <div className="container">
                            {/* <div className="row justify-content-center"> */}
                            <div className="row">

                                <div className="col-md-3" style={{top: 80}}>
                                    <div className="imgcard-group mb-0">
                                        <div className="imgcard imgcard-cascade wider">
                                            <div className="view overlay hm-white-slight">
                                                <img id="imgIslandLogo"
                                                     src={(!$.isEmptyObject(this.state.islandInfo) && !$.isEmptyObject(this.state.islandInfo.islandPics) && this.state.islandInfo.islandPics.logoPic) ? this.state.islandInfo.islandPics.logoPic.url : "http://www.theislandnw10.co.uk/sites/default/files/islandlogo_web_0.png"}
                                                     alt="Island Logo" className="img-fluid"
                                                />
                                                <a>
                                                    <div className="mask waves-effect waves-light"></div>
                                                </a>
                                            </div>
                                            <div className="imgcard-block-banner text-center">
                                                <h4 className="imgcard-title"><strong
                                                    style={{fontFamily: "Fjalla One"}}>Logo</strong>
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="imgcard-group mb-0">
                                        <div className="imgcard imgcard-cascade wider">
                                            <div className="view overlay hm-white-slight">
                                                <img id="imgIslandPrivate"
                                                     src={(!$.isEmptyObject(this.state.islandInfo) && !$.isEmptyObject(this.state.islandInfo.islandPics) && this.state.islandInfo.islandPics.hasOwnProperty('privatePic')) ? this.state.islandInfo.islandPics.privatePic.url : "https://www.privateislandsonline.com/uploads/resize/_722_image_5008630ab2.jpg-1920-1480.jpg"}
                                                     alt="Private Island" className="img-fluid"
                                                />
                                                <a>
                                                    <div className="mask waves-effect waves-light"></div>
                                                </a>
                                            </div>
                                            <div className="imgcard-block-banner text-center">
                                                <h4 className="imgcard-title"><strong
                                                    style={{fontFamily: "Fjalla One"}}>Private</strong>
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-5">
                                    <div className="imgcard-group mb-0">
                                        <div className="imgcard imgcard-cascade wider">
                                            <div className="view overlay hm-white-slight">
                                                <img id="imgIslandBanner"
                                                     src={(!$.isEmptyObject(this.state.islandInfo) && !$.isEmptyObject(this.state.islandInfo.islandPics) && this.state.islandInfo.islandPics.bannerPic) ? this.state.islandInfo.islandPics.bannerPic.url : "https://onehdwallpaper.com/wp-content/uploads/2015/07/Full-HD-Island-Desktop-Wallpapers.jpg"}
                                                     alt="Island Banner" className="img-fluid"
                                                />
                                                <a>
                                                    <div className="mask waves-effect waves-light"></div>
                                                </a>
                                            </div>
                                            <div className="imgcard-block-banner text-center">
                                                <h4 className="imgcard-title"><strong
                                                    style={{fontFamily: "Fjalla One"}}>Banner</strong>
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div id="divIslandPics" className="form-group row">
                        {(this.state.filesIslandPics.length > 0 || (!$.isEmptyObject(this.state.islandInfo) && !$.isEmptyObject(this.state.islandInfo.islandPics) && !$.isEmptyObject(this.state.islandInfo.islandPics.otherPics) && this.state.islandInfo.islandPics.otherPics.length > 0)) ? this.beforeSetPicsHtml(false) : ""}
                    </div>

                </form>
            </div>
        );
    }

    saveRoomDetails(e) {
        $("div.modal-footer").children().each((index, elem) => {
            $(elem).attr("disabled", "disabled")
        });
        $("#btnSaveRoomDetails").html('<i class="fa fa-spinner fa-spin fa-fw"></i> Saving');

        let islandInfo = this.state.islandInfo;
        islandInfo.RoomDetails = islandInfo.RoomDetails || [];
        let roomDetail = this.state.activeRoomInfo;
        // let roomDetail = {};
        if (!roomDetail.id) {
            roomDetail.id = new Date().getTime();
            roomDetail.createdDate = new Date(roomDetail.id);
            islandInfo.RoomDetails.push(roomDetail);
        }

        if (this.state.filesIslandRoomPics.length > 0) {
            let _this = this;

            function* fileGenerator() {
                if (_this.state.filesIslandRoomPics.length > 0) {
                    let roomPics = [];
                    for (const _file of _this.state.filesIslandRoomPics) {
                        const file = _file.file;
                        let fileObj = {name: file.name};

                        let roomPicUrl = yield HauteFire.uploadFile(file, "RoomPics");
                        fileObj.url = roomPicUrl;
                        roomPics.push(fileObj);
                    }

                    return roomPics;
                }
            }

            function generatorWrapper() {
                const generator = fileGenerator();

                function handleGenerator(yielded) {
                    if (!yielded.done) {
                        yielded.value.then((url) => {
                            return handleGenerator(generator.next(url));
                        })
                    }
                    else {

                        if (yielded.value.length > 0) {
                            _this.setState({filesIslandRoomPics: []});

                            var roomPics = yielded.value;
                            if (roomDetail.roomPics) {
                                roomDetail.roomPics.push(...roomPics)
                            } else {
                                roomDetail.roomPics = roomPics;
                            }

                            $("div.modal-footer").children().each((index, elem) => {
                                $(elem).removeAttr("disabled")
                            });
                            $("#btnSaveRoomDetails").html('SAVE');
                            _this.setState({roomFeatures: []});

                            _this.toggleRoomsModal();
                        }
                    }
                }

                return handleGenerator(generator.next());
            }

            generatorWrapper();
        }
        else {
            $("div.modal-footer").children().each((index, elem) => {
                $(elem).removeAttr("disabled")
            });
            $("#btnSaveRoomDetails").html('SAVE');
            this.setState({islandInfo, roomFeatures: []});

            this.toggleRoomsModal();
        }
    }

    changeRoomActiveStatus(e) {
        const roomId = $(e.currentTarget).attr("data-roomId");
        const islandInfo = this.state.islandInfo;
        this.state.islandInfo.RoomDetails.filter((room) => {
            if (room.id == roomId) {
                room.isActive = $(e.currentTarget).is(":checked")
            }
        });

        this.setState({islandInfo});
    }

    fillActiveRoomInfo(e) {
        $("div#divIslandRoomPics").html("");
        const roomId = $(e.currentTarget).attr("data-roomId");
        let activeRoomInfo = this.state.islandInfo.RoomDetails.filter((room) => {
            return room.id == roomId
        });
        if (!$.isEmptyObject(activeRoomInfo)) {
            activeRoomInfo = activeRoomInfo[0];
            let roomFeatures = activeRoomInfo.features || [];
            if (roomFeatures.length > 0) {
                roomFeatures = roomFeatures.map((obj, index) => {
                    return {id: (index + 1), text: obj}
                });
            }

            this.setState({
                roomFeatures,
                activeRoomInfo,
                filesIslandRoomPics: [],
                islandRoomsActiveTab: 'tab_Rooms_General'
            });

            this.toggleRoomsModal();
        }
    }

    showDeleteModal(e) {
        const deleteRoomId = $(e.currentTarget).attr("data-roomId");
        const deleteRoomName = $(e.currentTarget).attr("data-roomName");
        if ((deleteRoomId && deleteRoomName) != "") {
            const deleteAlert = () => (
                <SweetAlert
                    warning
                    showCancel
                    confirmBtnText="Yes, delete it!"
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="default"
                    title="Are you sure?"
                    roomId={deleteRoomId}
                    onCancel={this.hideDeleteModal.bind(this)}
                    onConfirm={this.deleteRoom.bind(this)}
                >
                    You want to delete {deleteRoomName} ?
                </SweetAlert>
            );

            this.setState({deleteRoomId, deleteRoomName, sweetAlertDelete: deleteAlert()});
        }
    }

    hideDeleteModal(e) {
        this.setState({sweetAlertDelete: null, deleteRoomId: "", deleteRoomName: ""});
    }

    deleteRoom(e) {
        const roomId = this.state.deleteRoomId;
        const roomName = this.state.deleteRoomName;
        if (roomId != "") {
            const islandInfo = this.state.islandInfo;
            const roomDetails = islandInfo.RoomDetails.filter((room) => {
                return room.id != roomId
            });
            islandInfo.RoomDetails = roomDetails;

            this.setState({islandInfo});
            this.hideDeleteModal(e);

            this.refs.notificator.success("Deleted", `${roomName} is deleted successfully!.`, 5000);
        }
    }

    renderIslandRooms(room) {
        let isRoomActive = room.isActive ? "defaultChecked" : "";

        return (<div className="col-sm-12 col-md-12" key={room.id}>
            <div className="card card-outline-primary">
                <div className="card-header">
                    <a className="btnRoomEdit" data-roomId={room.id} href="javascript:void(0)">{room.name}</a>

                    <div className="float-right mb-0"><a className="btnRoomDelete" title="Delete" data-roomId={room.id}
                                                         data-roomName={room.name}
                                                         style={{cursor: 'pointer'}}><i
                        className="fa fa-trash-o fa-lg"></i></a></div>

                    <div className="float-right mb-0" style={{marginRight: 15}}><a className="btnRoomEdit" title="Edit"
                                                                                   data-roomId={room.id}
                                                                                   style={{cursor: 'pointer'}}><i
                        className="fa fa-pencil-square-o fa-lg"></i></a></div>

                    <label className="switch switch-sm switch-text switch-info float-right mb-0"
                           style={{marginRight: 20}}>
                        <input type="checkbox" className="chkAllRoomActive switch-input" data-roomId={room.id}
                               defaultChecked={room.isActive ? true : false}/>
                        <span className="switch-label" data-on="On" data-off="Off"></span>
                        <span className="switch-handle"></span>
                    </label>

                </div>
                <div className="card-block">
                    <div className="row">
                        <div className="form-group col-sm-2"><label
                            className="label-heading">Features</label>
                        </div>
                        <div className="form-group col-sm-10">
                            {
                                room.features ? room.features.map((feature, index) => {
                                    return (<button className="btn btn-secondary" disabled="disabled"
                                                    key={`${room.id}-${index}`}>
                                        {feature}
                                    </button>)
                                }) : ""
                            }
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-sm-2"><label
                            className="label-heading">Default Occupency</label>
                        </div>
                        <div className="form-group col-sm-2">
                            <span>{room.defaultOcc}</span>
                        </div>

                        <div className="form-group col-sm-2"><label
                            className="label-heading">Minimum Occupency</label>
                        </div>
                        <div className="form-group col-sm-2">
                            <span>{room.minOcc}</span>
                        </div>

                        <div className="form-group col-sm-2"><label
                            className="label-heading">Maximum Occupency</label>
                        </div>
                        <div className="form-group col-sm-2">
                            <span>{room.maxOcc}</span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-sm-2"><label
                            className="label-heading">Price</label>
                        </div>
                        <div className="form-group col-sm-10">
                            <span>${room.price}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
    }

    renderNoRooms() {
        return (<div style={{float: 'none', margin: '0 auto'}}>
            <div style={{fontFamily: 'bambooFont', fontSize: 100}}>
                <span>No Rooms Available</span>
            </div>
            <div style={{textAlign: 'center'}}>
                <img src="../../../../img/norooms.gif" alt="No Rooms"/>
            </div>
        </div>);
    }

    renderIslandRoomPart() {
        return (<div>
                <div className="card-block">

                    <Button className="btn btn-outline-primary" onClick={this.addRoomsToggleModal.bind(this)}>
                        <i className="fa fa-bed" aria-hidden="true"></i> Add Rooms</Button>
                    <Modal isOpen={this.state.roomsModal} toggle={this.toggleRoomsModal} className='modal-lg'>
                        <ModalHeader id="modalHeader" toggle={this.toggleRoomsModal}>Room Details</ModalHeader>
                        <ModalBody>
                            <div className="row">
                                <div className="col-md-12 mb-4">
                                    <Nav tabs>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({active: this.state.islandRoomsActiveTab === 'tab_Rooms_General'})}
                                                onClick={() => {
                                                    this.toggleIslandRoomsTabs('tab_Rooms_General');
                                                }}
                                            >
                                                General
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({active: this.state.islandRoomsActiveTab === 'tab_Rooms_Gallery'})}
                                                onClick={() => {
                                                    this.toggleIslandRoomsTabs('tab_Rooms_Gallery');
                                                }}
                                            >
                                                Gallery
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                    <TabContent activeTab={this.state.islandRoomsActiveTab}>
                                        <TabPane tabId="tab_Rooms_General">
                                            {this.renderIslandRoomsGeneralPart()}
                                        </TabPane>
                                        <TabPane tabId="tab_Rooms_Gallery">
                                            {this.renderIslandRoomsGalleryPart()}
                                        </TabPane>
                                    </TabContent>
                                </div>
                            </div>
                        </ModalBody>
                        <ModalFooter>

                            <label className="switch switch-text switch-primary">
                                <input id="chkRoomActive" type="checkbox" className="switch-input" defaultChecked
                                       onChange={(e) => {
                                           let activeRoomInfo = this.state.activeRoomInfo;
                                           activeRoomInfo.isActive = $(e.currentTarget).is(":checked");
                                           this.setState({activeRoomInfo});
                                       }}/>
                                <span className="switch-label" data-on="On" data-off="Off"></span>
                                <span className="switch-handle"></span>
                            </label>

                            <Button id="btnSaveRoomDetails" color="primary" onClick={this.saveRoomDetails.bind(this)}>Save</Button>{' '}
                            <Button color="secondary" onClick={this.toggleRoomsModal}>Cancel</Button>
                        </ModalFooter>
                    </Modal>
                </div>

                <div className="container-fluid">
                    <div className="row">

                        {!$.isEmptyObject(this.state.islandInfo.RoomDetails) ? this.state.islandInfo.RoomDetails.map((room) => {
                            return this.renderIslandRooms(room)
                        }) : this.renderNoRooms()}

                    </div>
                </div>
            </div>

        );
    }

    renderIslandRoomsGeneralPart() {
        const {roomFeatures} = this.state;

        return (<form className="form-2orizontal">
            <div className="form-group">
                <label className="form-control-label" htmlFor="txtRoomName">Room name</label>
                <div className="controls">
                    <div className="input-prepend input-group">
                        <input id="txtRoomName" className="form-control" size="16"
                               type="text" placeholder="Room name" defaultValue={this.state.activeRoomInfo.name}
                               onChange={(e) => {
                                   let activeRoomInfo = this.state.activeRoomInfo;
                                   activeRoomInfo.name = e.currentTarget.value.trim();
                                   if (activeRoomInfo.name != "") {
                                       this.setState({activeRoomInfo})
                                   }
                               }} autoFocus={true}/>
                    </div>

                </div>
            </div>
            <div className="form-group">
                <label className="form-control-label" htmlFor="txtRoomType">Room type</label>
                <div className="controls">
                    <div className="input-prepend input-group">
                        <input id="txtRoomType" className="form-control" size="16"
                               type="text" placeholder="Room type" defaultValue={this.state.activeRoomInfo.type}
                               onChange={(e) => {
                                   let activeRoomInfo = this.state.activeRoomInfo;
                                   activeRoomInfo.type = e.currentTarget.value;
                                   if (activeRoomInfo.type != "") {
                                       this.setState({activeRoomInfo})
                                   }
                               }}/>
                    </div>

                </div>
            </div>
            <div className="form-group">
                <label className="form-control-label" htmlFor="txtRoomDesc">Description</label>
                <div className="controls">
                    <div className="input-group">
                        <TinyMCE
                            content={this.state.activeRoomInfo.description}
                            placeholder="Description ..."
                            onChange={(e) => {
                                let activeRoomInfo = this.state.activeRoomInfo;
                                activeRoomInfo.description = e.target.getContent();
                                if (activeRoomInfo.description != "") {
                                    this.setState({activeRoomInfo})
                                }
                            }}
                            style={{width: '100%'}}
                        />
                    </div>

                </div>
            </div>
            <div className="form-group">
                <label className="form-control-label" htmlFor="txtRoomFeatures">Features</label>
                <div className="controls">
                    <div className="input-prepend input-group">
                        <_ReactTags tags={roomFeatures}
                                    handleDelete={this.handleDelete.bind(this)}
                                    handleAddition={this.handleAddition.bind(this)}
                                    handleDrag={this.handleDrag.bind(this)}
                                    placeholder="Add feature"/>
                    </div>
                    <div className="help-block">
                        <div className="checkbox">
                            <label htmlFor="chkRoomCommonFeatures">
                                <input type="checkbox" id="chkRoomCommonFeatures" name="chkRoomCommonFeatures"
                                       defaultChecked={this.state.activeRoomInfo.isCommonFeatures}
                                       onChange={(e) => {
                                           let activeRoomInfo = this.state.activeRoomInfo;
                                           activeRoomInfo.isCommonFeatures = $(e.currentTarget).is(":checked");
                                           this.setState({activeRoomInfo});
                                       }}/>
                                Common Room Features
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="form-group col-sm-4">
                    <label htmlFor="txtRoomDefOcc">Default occupency</label>
                    <input id="txtRoomDefOcc" className="form-control" size="16"
                           type="number" min="1"
                           defaultValue={this.state.activeRoomInfo.defaultOcc}
                           onChange={(e) => {
                               let activeRoomInfo = this.state.activeRoomInfo;
                               activeRoomInfo.defaultOcc = e.currentTarget.value.trim();
                               if (activeRoomInfo.defaultOcc != "") {
                                   activeRoomInfo.defaultOcc = parseInt(activeRoomInfo.defaultOcc);
                                   this.setState({activeRoomInfo})
                               }
                           }}
                    />
                </div>
                <div className="form-group col-sm-4">
                    <label htmlFor="txtRoomMinOcc">Minimum occupency</label>
                    <input id="txtRoomMinOcc" className="form-control" size="16"
                           type="number" min="1" defaultValue={this.state.activeRoomInfo.minOcc}
                           onChange={(e) => {
                               let activeRoomInfo = this.state.activeRoomInfo;
                               activeRoomInfo.minOcc = e.currentTarget.value.trim();
                               if (activeRoomInfo.minOcc != "") {
                                   activeRoomInfo.minOcc = parseInt(activeRoomInfo.minOcc);
                                   this.setState({activeRoomInfo})
                               }
                           }}
                    />
                </div>
                <div className="col-sm-4">
                    <div className="form-group">
                        <label htmlFor="txtRoomMaxOcc">Maximum occupency</label>
                        <input id="txtRoomMaxOcc" className="form-control" size="16"
                               type="number" max="5" defaultValue={this.state.activeRoomInfo.maxOcc}
                               onChange={(e) => {
                                   let activeRoomInfo = this.state.activeRoomInfo;
                                   activeRoomInfo.maxOcc = e.currentTarget.value.trim();
                                   if (activeRoomInfo.maxOcc != "") {
                                       activeRoomInfo.maxOcc = parseInt(activeRoomInfo.maxOcc);
                                       this.setState({activeRoomInfo})
                                   }
                               }}
                        />
                    </div>
                </div>
            </div>
            <div className="form-group">
                <label className="form-control-label" htmlFor="txtRoomPrice">Price</label>
                <div className="controls">
                    <div className="input-prepend input-group">
                        <span className="input-group-addon">$</span>
                        <input id="txtRoomPrice" className="form-control" size="16"
                               type="number" defaultValue={this.state.activeRoomInfo.price} onChange={(e) => {
                            let activeRoomInfo = this.state.activeRoomInfo;
                            activeRoomInfo.price = e.currentTarget.value.trim();
                            if (activeRoomInfo.price != "") {
                                activeRoomInfo.price = parseInt(activeRoomInfo.price);
                                this.setState({activeRoomInfo})
                            }
                        }}/><span className="input-group-addon">.00</span>
                    </div>

                </div>
            </div>
            <div className="form-group">
                <label className="form-control-label" htmlFor="txtRoomPrice">Price</label>
                <div className="controls">
                    <div className="input-prepend input-group">
                        <span className="input-group-addon">$</span>
                        <input id="txtRoomPrice" className="form-control" size="16"
                               type="number"/><span className="input-group-addon">.00</span>
                    </div>

                </div>
            </div>
        </form>);
    }

    renderIslandRoomsGalleryPart() {
        return (
            <div className="card-block">
                <form className="form-2orizontal">
                    <div className="form-group row">
                        <label className="col-md-3 form-control-label" htmlFor="fileIslandRoomPics">Room
                            Pictures</label>
                        <div className="col-md-4">
                            <input type="file" id="fileIslandRoomPics" name="fileIslandRoomPics" accept="image/*"
                                   multiple/>
                        </div>
                    </div>
                </form>

                <div id="divIslandRoomPics" className="form-group row">
                    {this.state.filesIslandRoomPics.length > 0 || this.state.activeRoomInfo.roomPics ? this.beforeSetPicsHtml(true) : ""}
                </div>
            </div>
        );
    }

    uploadIslandAndRoomPics() {
        const _this = this;

        function* fileGenerator() { //create generator
            var bannerPicObj = {}, logoObj = {}, privatePicObj = {}, otherPicsObj = [];
            if (!$.isEmptyObject(_this.state.fileBannerPic)) {
                bannerPicObj.name = _this.state.fileBannerPic.name;
                let bannerPic = yield HauteFire.uploadFile(_this.state.fileBannerPic, "IslandPics/resized");
                bannerPicObj.url = bannerPic;
            }
            if (!$.isEmptyObject(_this.state.fileLogo)) {
                logoObj.name = _this.state.fileLogo.name;
                let logoPic = yield HauteFire.uploadFile(_this.state.fileLogo, "HomePage/Logos");
                logoObj.url = logoPic;
                logoObj.islandId = _this.state.islandInfo.id;
                logoObj.islandName = _this.state.islandInfo.name;
            }
            if (!$.isEmptyObject(_this.state.filePrivatePic)) {
                privatePicObj.name = _this.state.filePrivatePic.name;
                let privatePic = yield HauteFire.uploadFile(_this.state.filePrivatePic, "IslandPics/resized");
                privatePicObj.url = privatePic;
            }
            if (_this.state.filesIslandPics.length > 0) {
                for (let file of _this.state.filesIslandPics) {
                    const _file = file.file;
                    let obj = {name: _file.name};

                    let url = yield HauteFire.uploadFile(_file, "IslandPics/resized");
                    obj.url = url;

                    otherPicsObj.push(obj);
                }
            }

            return {bannerPic: bannerPicObj, logoPic: logoObj, privatePic: privatePicObj, otherPics: otherPicsObj};
        }

        function fileWrapper() {
            let fileGen = fileGenerator();

            function handle(yielded) {
                if (!yielded.done) {
                    yielded.value.then((url) => {
                        return handle(fileGen.next(url));
                    });
                }
                else {
                    if (yielded.value) {
                        _this.setState({fileLogo: {}, filePrivatePic: {}, fileBannerPic: {}, filesIslandPics: []});

                        const islandInfo = _this.state.islandInfo;
                        if (!islandInfo.islandPics)
                            islandInfo.islandPics = {};
                        if (!$.isEmptyObject(yielded.value.bannerPic)) {
                            islandInfo.islandPics.bannerPic = yielded.value.bannerPic;
                        }
                        if (!$.isEmptyObject(yielded.value.logoPic)) {
                            islandInfo.islandPics.logoPic = yielded.value.logoPic;

                            HauteFire.addLogoUrl(yielded.value.logoPic);
                        }
                        if (!$.isEmptyObject(yielded.value.privatePic)) {
                            islandInfo.islandPics.privatePic = yielded.value.privatePic;
                        }
                        if (yielded.value.otherPics) {
                            // let islandPics = yielded.value.islandPics;
                            // islandPics = islandPics.split(",").filter((url) => {
                            //     return url.trim() != ""
                            // });
                            if (!$.isEmptyObject(islandInfo.islandPics.otherPics)) {
                                let otherPics = yielded.value.otherPics;
                                for (let pic of otherPics) {
                                    islandInfo.islandPics.otherPics.push(pic);
                                }
                            }
                            else {
                                islandInfo.islandPics.otherPics = yielded.value.otherPics;
                            }
                        }

                        HauteFire.addUpdate(islandInfo.id, islandInfo, "IslandDetails");

                        $("#btnSaveIsland").removeAttr("disabled");
                        $("#btnSaveIsland").html('<i className="fa fa-floppy-o" aria-hidden="true"></i> SAVE');

                        _this.refs.notificator.success("Added", `${islandInfo.name} is added successfully!.`, 5000);

                        const params = _this.props.match.params;
                        if ($.isEmptyObject(params)) {
                            $("#txtIslandName").val("");
                            $("#txtIslandRooms").val("");
                            $("#txtIslandGuests").val("");
                            $("#txtIslandPrice").val("");
                            $("#txtIslandTagLine").val("");
                            let descriptionBody = $("iframe")[0].contentWindow.document.body;   //description
                            if (descriptionBody) {
                                descriptionBody.innerHTML = "";
                            }
                            _this.setState({
                                islandInfo: {}, islandActiveTab: 'tab_General',
                                islandRoomsActiveTab: 'tab_Rooms_General',
                                activities: [],
                                roomFeatures: [],
                                fileBannerPic: {},
                                fileLogo: {},
                                filePrivatePic: {},
                                filesIslandPics: [],
                                filesIslandRoomPics: [],
                                roomsModal: false,
                                activeRoomInfo: {},
                                sweetAlertShow: null,
                                deleteRoomId: "",
                                deleteRoomName: "",
                                sweetAlertDelete: null,
                                islandCategories: []
                            });
                            _this.fillCategories();
                        }
                    }
                }
            }

            return handle(fileGen.next());
        }

        fileWrapper();
    }

    saveIslandInfo() {
        let islandInfo = this.state.islandInfo;
        if (!islandInfo.id) {
            islandInfo.id = new Date().getTime();
        }
        islandInfo.isActive = $("#chkIslandActive").is(":checked");

        $("#btnSaveIsland").attr("disabled", "disabled");
        $("#btnSaveIsland").html('<i class="fa fa-spinner fa-spin fa-fw"></i> Saving');

        if (this.state.fileLogo || this.state.filePrivatePic || this.state.fileBannerPic || this.state.filesIslandPics)
            this.uploadIslandAndRoomPics();
        else {
            HauteFire.addUpdate(islandInfo.id, islandInfo, "IslandDetails");

            $("#btnSaveIsland").removeAttr("disabled");
            $("#btnSaveIsland").html('<i className="fa fa-floppy-o" aria-hidden="true"></i> SAVE');

            this.refs.notificator.success("Added", `${islandInfo.name} is added successfully!.`, 5000);

            const params = this.props.match.params;
            if ($.isEmptyObject(params)) {
                $("#txtIslandName").val("");
                $("#txtIslandRooms").val("");
                $("#txtIslandGuests").val("");
                $("#txtIslandPrice").val("");
                $("#txtIslandTagLine").val("");
                let descriptionBody = $("iframe")[0].contentWindow.document.body;   //description
                if (descriptionBody) {
                    descriptionBody.innerHTML = "";
                }
                this.setState({
                    islandInfo: {}, islandActiveTab: 'tab_General',
                    islandRoomsActiveTab: 'tab_Rooms_General',
                    activities: [],
                    roomFeatures: [],
                    fileBannerPic: {},
                    fileLogo: {},
                    filePrivatePic: {},
                    filesIslandPics: [],
                    filesIslandRoomPics: [],
                    roomsModal: false,
                    activeRoomInfo: {},
                    sweetAlertShow: null,
                    deleteRoomId: "",
                    deleteRoomName: "",
                    sweetAlertDelete: null,
                    islandCategories: []
                });
                this.fillCategories();
            }
        }
    }

    editContact(e) {
        const contactId = e.currentTarget.attributes["data-id"].value;
        if (contactId != (undefined || null)) {
            this.setState({editContactId: contactId});

            const contact = this.state.islandInfo.contactDetails.find((obj) => {
                return obj.id == contactId
            });
            if (contact != (undefined || null)) {
                $("#txtContactEmail").val(contact.email);
                $("#txtContactNumber").val(contact.number);
            }
        }
    }

    deleteContact(e) {
        const contactId = e.currentTarget.attributes["data-id"].value;
        if (contactId != (undefined || null)) {
            let islandInfo = this.state.islandInfo;
            let contactDetails = islandInfo.contactDetails;
            contactDetails = contactDetails.filter((contact) => {
                return contact.id != contactId
            });
            islandInfo.contactDetails = contactDetails;

            this.setState({islandInfo});
        }
    }

    renderContactDetailsPart() {
        return (<div>
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <b>{this.state.islandInfo.name}</b> Contact info
                            <div className="card-actions">
                                <a href="#" className="btn-setting"><i className="icon-settings"></i></a>
                                <a href="#" className="btn-minimize"><i className="icon-arrow-up"></i></a>
                                <a href="#" className="btn-close"><i className="icon-close"></i></a>
                            </div>
                        </div>
                        <div className="card-block">

                            <div className="form-group">
                                <label className="form-control-label" htmlFor="txtContactEmail">Email</label>
                                <div className="controls">
                                    <div className="input-prepend input-group">
                                        <input id="txtContactEmail" className="form-control" size="16" type="email"
                                               ref="contactEmail"/>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="form-control-label" htmlFor="txtContactNumber">Contact
                                    Number</label>
                                <div className="controls">
                                    <div className="input-group">
                                        <input id="txtContactNumber" className="form-control" size="16" type="text"
                                               ref="contactNumber"/>
                                    </div>
                                </div>
                            </div>
                            <div className="form-actions">
                                <button className="btn btn-primary" onClick={() => {
                                    let email = this.refs.contactEmail.value.trim();
                                    let number = this.refs.contactNumber.value.trim();
                                    if ((email && number) != "") {
                                        let islandInfo = this.state.islandInfo;

                                        if (this.state.editContactId == "") {
                                            islandInfo.contactDetails = islandInfo.hasOwnProperty('contactDetails') ? islandInfo.contactDetails : [];
                                            let contactObj = {};
                                            contactObj.id = Date.now();
                                            contactObj.email = email;
                                            contactObj.number = number;

                                            islandInfo.contactDetails.push(contactObj);
                                        }
                                        else {
                                            const contactId = this.state.editContactId;
                                            let contactDetails = islandInfo.contactDetails;
                                            let contact = contactDetails.find((obj) => {
                                                return obj.id == contactId
                                            });
                                            if (contact != (undefined || null)) {
                                                contact.email = email;
                                                contact.number = number;

                                                islandInfo.contactDetails = contactDetails;
                                            }
                                        }

                                        this.setState({islandInfo, editContactId: ""});

                                        this.refs.contactEmail.value = "";
                                        this.refs.contactNumber.value = "";
                                    }
                                }}>Save changes
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                {this.state.islandInfo.hasOwnProperty('contactDetails') ? this.state.islandInfo.contactDetails.map((contact, index) => {
                    return this.renderIslandContactDetails(contact, index)
                }) : ""}
            </div>
        </div>)
    }

    renderIslandContactDetails(contact, index) {
        return (
            <div className="col-12 col-sm-6 col-md-6 island-contact" key={contact.id}>
                <div className="text-white bg-info text-center card">
                    <div className="card-header" style={{backgroundColor: '#1E9ECB'}}>
                        <label className="switch switch-sm switch-text switch-info float-right mb-0">
                            <a className="edit-contact" title="Edit" style={{marginRight: 10}}
                               data-id={contact.id} data-email={contact.email} data-number={contact.number}>
                                <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                            </a>
                            <a className="delete-contact" title="Delete" data-id={contact.id} data-email={contact.email}
                               data-number={contact.number}><i className="fa fa-trash-o" aria-hidden="true"></i>
                            </a>
                        </label>
                    </div>
                    <div className="card-body card-block">
                        <blockquote className="card-bodyquote">
                            <div className="row form-group">
                                <div className="col-12"><label className=" form-control-label">
                                    <a href={`mailto:${contact.email}`} style={{color: 'white'}}>{contact.email}</a>
                                </label>
                                </div>
                                <div className="col-12"><p className="form-control-static">
                                    <a href={`tel:${contact.number}`} style={{color: 'white'}}>{contact.number}</a>
                                </p>
                                </div>
                            </div>
                        </blockquote>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return (
            <div className="animated fadeIn">

                <div className="animated fadeIn">
                    <div className="row">

                        <div className="col-md-12 mb-4">
                            <button id="btnSaveIsland" type="button" className="btn btn-primary float-right"
                                    onClick={this.saveIslandInfo.bind(this)}>
                                <i className="fa fa-floppy-o" aria-hidden="true"></i> SAVE
                            </button>

                            <label className="switch switch-text switch-primary float-right" style={{marginRight: 15}}>
                                <input id="chkIslandActive" type="checkbox" className="switch-input" defaultChecked/>
                                <span className="switch-label" data-on="On" data-off="Off"></span>
                                <span className="switch-handle"></span>
                            </label>

                        </div>

                        <div className="col-md-12 mb-4">
                            <Nav tabs className="nav-justified">
                                <NavItem>
                                    <NavLink
                                        className={classnames({active: this.state.islandActiveTab === 'tab_General'})}
                                        onClick={() => {
                                            this.toggleIslandTabs('tab_General');
                                        }}
                                    >
                                        <i className="fa fa-newspaper-o" aria-hidden="true"></i> General
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({active: this.state.islandActiveTab === 'tab_Rooms'})}
                                        onClick={() => {
                                            this.toggleIslandTabs('tab_Rooms');
                                        }}
                                    >
                                        <i className="fa fa-bed" aria-hidden="true"></i> Rooms
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({active: this.state.islandActiveTab === 'tab_ContactDetails'})}
                                        onClick={() => {
                                            this.toggleIslandTabs('tab_ContactDetails');
                                        }}
                                    >
                                        <i className="fa fa-phone" aria-hidden="true"></i> Contact Details
                                    </NavLink>
                                </NavItem>

                            </Nav>
                            <TabContent activeTab={this.state.islandActiveTab}>
                                <TabPane tabId="tab_General">
                                    {this.renderIslandGenralPart()}
                                </TabPane>
                                <TabPane tabId="tab_Rooms">
                                    {this.renderIslandRoomPart()}
                                </TabPane>
                                <TabPane tabId="tab_ContactDetails">
                                    {this.renderContactDetailsPart()}
                                </TabPane>

                            </TabContent>
                        </div>
                    </div>
                </div>

                {this.state.sweetAlertDelete}
                <ReactNotify ref='notificator'/>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/IslandManagement/AddUpdateIsland/AddUpdateIsland.js